var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardCta',{class:_vm.$style.card,attrs:{"buttonProps":{
    type: 'primary',
    class: _vm.$style.buttonProps,
  },"ctaText":_vm.widgetInfo.buttonText},on:{"click":function($event){return _vm.handleRedirect()}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('HeadingMedium',{attrs:{"hasMargin":false}},[_vm._v(" "+_vm._s(_vm.widgetInfo.title)+" ")])]},proxy:true},{key:"body",fn:function(){return [_c('ParagraphBody',{class:_vm.$style.widgetText},[_vm._v(" "+_vm._s(_vm.widgetInfo.text)+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }